export default __webpack_public_path__ + "5014069f8f01d28af6ef80ead817616f.png";